export const MainSlate = 'Main'